import { HttpClient } from '@wix/sdk-types';
import {
  InvokeEditorFunctionApplicationErrors,
  InvokeEditorFunctionResponse,
  invokeEditorFunction as universalInvokeEditorFunction,
} from './functions-v1-editor-function-editor-functions.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/functions' };

export function invokeEditorFunction(
  httpClient: HttpClient
): InvokeEditorFunctionSignature {
  return (functionId: string) =>
    universalInvokeEditorFunction(
      functionId,
      // @ts-ignore
      { httpClient }
    );
}

interface InvokeEditorFunctionSignature {
  /**
   * Invokes the specified Editor Function. Returns a NOT_FOUND error if editor function can't be found by the provided id.
   * @param - Id of the function requested to be invoked
   * @returns Invoke Function Response
   */
  (functionId: string): Promise<
    InvokeEditorFunctionResponse & {
      __applicationErrorsType?: InvokeEditorFunctionApplicationErrors;
    }
  >;
}

export {
  EditorFunction,
  InvokeEditorFunctionRequest,
  InvokeEditorFunctionResponse,
} from './functions-v1-editor-function-editor-functions.universal.js';
